import { ExportStatus } from './common';

export const Kind = 'EXPORT_CARE_GAP_FINDINGS' as const;
export { ExportStatus as Status };
